export default function initWorkHandler() {
    const $ = jQuery;
    const work = document.querySelector('#works')
    if(work){
        jQuery(work).on('click','.pagination ul li',function(){
            if($(this).hasClass('disabled') || $(this).hasClass('current')){
                alert($(this).attr('class'))
                return
            }
            const page = $(this).data("page")
            $.get(`${theme_url}/blocks/loophandlers/work-handler.php?numPosts=6&pageNumber=${page}`,function(data){
                work.innerHTML = data
            })
        })
        /* $.get(`${theme_url}/blocks/loophandlers/work-handler.php?agency=2595`,function(data){
            work.innerHTML = data
        }) */
    }
}